export default __webpack_public_path__ + "static/media/marke_3.9eae5dda.png";